import Controller from '../abstracts/Controller';
import 'scss-templates/t-cart.scss';

export default class CartController extends Controller {
  static get COMPONENTS() {
    return [
      'CartComponent',
      'ShowPasswordComponent',
      'StoreLocatorComponent',
      'CollapseComponent',
      'PromocodeComponent',
      'WishlistComponent'
    ];
  }
}
